var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn row-center",on:{"click":_vm.change}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.iconShow(),"alt":"图标"}}),_c('span',{staticClass:"content",style:(_vm.fontStyle())},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }